<template>
    <div class="competitionCreate">
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <div slot="headerBtns">
                <button class="h_search_btn" @click="$router.push('/search')"></button>
            </div>
        </page-header>
        <page-header class="sub_header" :header-title="$t('create_contest')" ></page-header>
        <competition-write-component :competition-type="'competitionWrite'"></competition-write-component>
    </div>
</template>

<script>
import CompetitionWriteComponent from "@/components/competition/CompetitionWriteComponent";

export default {
    name: "CompetitionCreate",
    mixins: [],
    components: {
        CompetitionWriteComponent,
    },
    inject: [],
    provide() {
        return {
            competitionVueSetData : this.setData
        }
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value
        }

    },
    watch: {},
}
</script>

<style scoped>

</style>
